/**
 * B2C Translations Barrel
 * =======================
 * Merges shared common translations with all B2C-specific translations.
 */

import { commonTranslations, mergeTranslations, Translations } from '../shared/i18n';
import { authTranslations } from './auth';
import { invoiceListTranslations } from './invoiceList';
import { invoiceDetailTranslations } from './invoiceDetail';
import { dashboardTranslations } from "./dashboard";
import { settingsTranslations } from './settings';
import { bankStatementsTranslations } from './bankStatements';
import { trashTranslations } from './trash';
import { reconciliationTranslations } from './reconciliation';
import { onboardingTranslations } from './onboarding';
import { filesTranslations } from "./files";
import { aboutTranslations } from './about';
import { landingTranslations } from "./landing";
import { contactTranslations } from './contact';
import { cookiesTranslations } from './cookies';

export const allTranslations: Translations = mergeTranslations(
  commonTranslations,
  authTranslations,
  invoiceListTranslations,
  invoiceDetailTranslations,
  dashboardTranslations,
  settingsTranslations,
  bankStatementsTranslations,
  trashTranslations,
  reconciliationTranslations,
  onboardingTranslations,
  filesTranslations,
  landingTranslations,
  aboutTranslations,
  contactTranslations,
  cookiesTranslations,
);
